<section
  class="row mb-4 pl-2 border-left"
  *ngIf="
    !informacionEstablecimiento_anterior ||
      authService.getTipoUser() === tipo_prestador ||
      authService.getTipoUser() === tipo_depositario;
    else comparativo
  "
  >

  <!-- Datos Prestador -->
  <section class="col-12 mb-4 mt-4 border-bottom">
    <footer class="row">
      <h2 class="col-9 h5 font-weight-bold mb-2">Datos del prestador</h2>
      <p class="col-3 small">
        Última actualización:
        <strong>{{
          informacionEstablecimiento.fecha_ultima_actualizacion
            | date: "d/MMM/yyyy, h:mm a"
        }}</strong>
      </p>

      <ng-container
        *ngIf="
          datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia;
          else es_guia
        "
      >
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Representante legal</label>
          <p>
            <strong>{{
              informacionEstablecimiento.nombre_representante_legal
            }}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Número identificación</label>
          <p>
            <strong>{{
              informacionEstablecimiento.numero_identificacion_representante_legal
            }}</strong>
          </p>
        </div>
      </ng-container>

      <ng-template #es_guia>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Nombre representante legal</label>
          <p>
            <strong>{{informacionEstablecimiento.nombre_representante_legal}}</strong>
          </p>
        </div>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Número identificación</label>
          <p>
            <strong>{{
              informacionEstablecimiento.numero_identificacion
            }}</strong>
          </p>
        </div>
      </ng-template>

      <ng-container
        *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble &&
        datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma &&
        datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia"
      >
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Patrimonio neto</label>
          <p>
            <strong>{{
              informacionEstablecimiento.patrimonio_neto | currency: "COP"
            }}</strong>
          </p>
        </div>
      </ng-container>

      <div
        class="col-sm-12 col-md-3"
        *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento"
      >
        <label class="small mb-0">Número de empleados</label>
        <p>
          <strong>{{ informacionEstablecimiento.numero_empleados }}</strong>
        </p>
      </div>

      <div
        class="col-sm-12 col-md-3"
        *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento"
      >
        <label class="small mb-0">Último Año Renovación Matricula Mercantil</label>
        <p>
          <strong>{{ informacionEstablecimiento.Ultimo_Anio_Renovado_Rm }}</strong>
        </p>
      </div>

      <ng-container >
        <div class="col-sm-12 col-md-12 text-right mb-3">
          <label class="small text-secondary mb-0">Actividad económica</label><br>
          <button type="button" class="btn btn-primary btn-sm"
          (click)="consultarActividadesPrestadorFuncionario()">
            Ver actividades
          </button>
        </div>
      </ng-container>
    </footer>
  </section>

  <!-- Datos Establecimiento -->
  <section class="col-12 mb-4 mt-1 border-bottom">
    <footer class="row">
      <!-- Establecimiento -->
      <ng-container
        *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento"
      >
        <h2 class="col-12 h5 font-weight-bold mb-2">
          Datos del establecimiento
        </h2>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Nombre</label>
          <p>
            <strong>{{ informacionEstablecimiento.razon_social }}</strong>
          </p>
        </div>
        <div
          class="col-sm-12 col-md-3"
          *ngIf="informacionEstablecimiento.matricula"
        >
          <label class="small mb-0">Matrícula mercantíl</label>
          <p>
            <strong>{{ informacionEstablecimiento.matricula }}</strong>
          </p>
        </div>
        <!--<div class="col-sm-12 col-md-3">
          <label class="small mb-0">Último año renovado</label>
          <p>
            <strong>{{
              informacionEstablecimiento.ultimo_anio_renovado
            }}</strong>
          </p>
        </div>-->
      </ng-container>
      <!-- Inmueble -->
      <ng-container
        *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_inmueble"
      >
        <h2 class="col-12 h5 font-weight-bold mb-2">Datos del inmueble</h2>
      </ng-container>
      <!-- Guia -->
      <ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_guia">
        <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
        <div class="col-sm-12 col-md-3">
          <label class="small mb-0">Nombre de guia</label>
          <p>
            <strong>{{ informacionEstablecimiento.nombre_gerente }}</strong>
          </p>
        </div>
      </ng-container>
      <!-- Datos generales -->
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Último año renovado RNT</label>
        <p>
          <strong>{{
            informacionEstablecimiento.ultimo_anio_renovado_rnt
          }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Dirección</label>
        <p>
          <strong>{{ informacionEstablecimiento.direccion_comercial }}</strong>
        </p>
      </div>

      <div class="col-sm-12 col-md-3" *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_plataforma">
        <label class="small mb-0">País</label>
        <p>
          <strong>{{ informacionEstablecimiento.desc_pais_notificacion }}</strong>
        </p>
      </div>


      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Departamento</label>
        <p>
          <strong>{{ informacionEstablecimiento.departamento }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Municipio</label>
        <p>
          <strong>{{ informacionEstablecimiento.municipio }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Cámara de comercio</label>
        <p>
          <strong>{{
            informacionEstablecimiento.desc_camara_largo ||
              datoSolicitudSharedModel.data.descripcion_camara
          }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Categoría</label>
        <p>
          <strong>{{ informacionEstablecimiento.categoria }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Sub categoría</label>
        <p>
          <strong>{{ informacionEstablecimiento.subcategoria }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3"
      *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble && datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia && datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma">
        <label class="small mb-0">Último año renovado Matricula Mercantil</label>
        <p><strong>{{ informacionEstablecimiento.ultimo_anio_renovado }}</strong></p>
      </div>
      <!-- Brtn Actividades economicas -->
      <div class="col-sm-12 col-md-12 text-right mb-3"
      *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble && datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia && datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma">
        <label class="small text-secondary mb-0">Actividad económica</label><br>
        <button type="button" class="btn btn-primary btn-sm" (click)="consultarActividadesEstablecimiento(informacionEstablecimiento)">
          Ver actividades
        </button>
      </div>
    </footer>
  </section>

  <!-- Depositario provisional -->
  <section
    *ngIf="
      informacionEstablecimiento.numero_identificacion_usuario_provisional !==
      null
    "
    class="col-12 mb-4 mt-1 border-bottom"
  >
    <footer class="row">
      <!-- Usuario depositario -->
      <h2 class="col-12 h5 font-weight-bold mb-2">Depositario provisional</h2>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Nombre</label>
        <p>
          <strong>{{
            informacionEstablecimiento.nombre_usuario_provisional +
              " " +
              informacionEstablecimiento.apellido_usuario_provisional
          }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Número identificación</label>
        <p>
          <strong>{{
            informacionEstablecimiento.numero_identificacion_usuario_provisional
          }}</strong>
        </p>
      </div>
      <!-- <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Tipo identificación</label>
        <p>
          <strong>{{ informacionEstablecimiento.ultimo_anio_renovado }}</strong>
        </p>
      </div> -->
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Cargo</label>
        <p>
          <strong>{{
            informacionEstablecimiento.cargo_usuario_provisional
          }}</strong>
        </p>
      </div>
      <div class="col-sm-12 col-md-3">
        <label class="small mb-0">Correo electrónico</label>
        <p>
          <strong>{{
            informacionEstablecimiento.correo_usuario_provisional
          }}</strong>
        </p>
      </div>
    </footer>
  </section>

  <!-- Datos adicionales prestador -->
  <section class="col-12 row mb-4">
    <h2 class="col-12 h5 font-weight-bold mb-2">
      Datos adicionales del prestador
    </h2>
    <!-- Contacto -->
    <div class="col-sm-12 col-md-4" *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma;">
      <header class="mb-3">
        <h2 class="h6 font-weight-bold mb-4">Contacto</h2>
      </header>
      <footer class="row">
        <p class="col-5 small">Teléfono Fijo:</p>
        <p class="col-7 font-weight-bold small">
          {{ informacionEstablecimiento.numero_telefonico }}
        </p>
        <p class="col-5 small">Celular:</p>
        <p class="col-7 font-weight-bold small">
          {{ informacionEstablecimiento.numero_celular }}
        </p>
        <p class="col-5 small">Número fax:</p>
        <p class="col-7 font-weight-bold small">
          {{ informacionEstablecimiento.fax }}
        </p>
        <p class="col-5 small">Correo eletrónico:</p>
        <p class="col-7 font-weight-bold small text-large">
          {{ informacionEstablecimiento.correo_electronico }}
        </p>
      </footer>
    </div>

    <!-- Notificaciones -->
    <div class="col-sm-12 col-md-4">
      <header class="mb-3">
        <h2 class="h6 font-weight-bold mb-4">Notificaciones</h2>
      </header>
      <footer class="row">
        <p class="col-6 small">Departamento notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.departamento_notificacion }}
        </p>
        <p class="col-6 small">Municipio notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.municipio_notificacion }}
        </p>
        <p class="col-6 small">Teléfono notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.numero_telefonico_notificacion }}
        </p>
        <p class="col-6 small">Dirección notificaciones:</p>
        <p class="col-6 font-weight-bold small">
          {{ informacionEstablecimiento.direccion_notificacion }}
        </p>
        <div class="notification-email w-100" *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia &&
        datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble">
          <p class="col-6 small">Correo electronico notificaciones:</p>
          <p class="col-6 font-weight-bold small text-break">
            {{ informacionEstablecimiento.correo_electronico_notificacion }}
          </p>
        </div>
      </footer>
    </div>
  </section>
</section>

<!-- comparativo -->
<ng-template #comparativo>
  <section class="row mb-4 pl-2">
    <!-- Version Actual -->
    <section class="col-6 border-right border-left">
      <section class="row">
        <h3 class="col-8 h4 font-weight-bold mt-1 border-actual mt-4">
          Versión actual
        </h3>
        <p class="col-4 small mt-4">
          Última actualización: <br /><strong>{{
            informacionEstablecimiento.fecha_ultima_actualizacion
              | date: "d/MMM/yyyy, h:mm a"
          }}</strong>
        </p>
        <section class="col-12">
          <footer class="row">
            <h2 class="col-12 h5 font-weight-bold mb-2 mt-2">
              Datos del prestador
            </h2>
            <ng-container
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia;
                else es_guia
              "
            >
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Representante legal</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.nombre_representante_legal ===
                    informacionEstablecimiento_anterior.nombre_representante_legal
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento.nombre_representante_legal
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Número identificación</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.numero_identificacion_representante_legal ===
                    informacionEstablecimiento_anterior.numero_identificacion_representante_legal
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento.numero_identificacion_representante_legal
                  }}</strong>
                </p>
              </div>
            </ng-container>

            <ng-template #es_guia>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Nombre representante legal</label>
                <p>
                  <strong>{{informacionEstablecimiento.nombre_representante_legal}}</strong>
                </p>
              </div>

              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Número identificación</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.numero_identificacion ===
                    informacionEstablecimiento_anterior.numero_identificacion
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento.numero_identificacion
                  }}</strong>
                </p>
              </div>
            </ng-template>

            <ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble &&
            datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia &&
            datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma">
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Patrimonio neto</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.patrimonio_neto ===
                    informacionEstablecimiento_anterior.patrimonio_neto
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento.patrimonio_neto | currency: "COP"
                  }}</strong>
                </p>
              </div>
            </ng-container>

            <div
              class="col-sm-12 col-md-6"
              *ngIf="
              datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento
              "
            >
              <label class="small mb-0">Número de empleados</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_empleados ===
                  informacionEstablecimiento_anterior.numero_empleados
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{
                  informacionEstablecimiento.numero_empleados
                }}</strong>
              </p>
            </div>

            <ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento">
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Último Año Renovación Matricula Mercantil</label>
                <p
                [style.backgroundColor]="
                informacionEstablecimiento.Ultimo_Anio_Renovado_Rm ===
                informacionEstablecimiento_anterior.Ultimo_Anio_Renovado_Rm
                    ? ''
                    : '#b2dfdb'
                "><strong>{{informacionEstablecimiento.Ultimo_Anio_Renovado_Rm}}</strong></p>
              </div>
            </ng-container>



            <!--<ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia">-->
              <div class="col-sm-12 col-md-12 text-right">
                <label class="small text-secondary mb-0">Actividad económica</label><br>
                <button type="button" class="btn btn-primary btn-sm" (click)="consultarActividadesPrestadorFuncionario()">
                  Ver actividades
                </button>
              </div>
            <!--</ng-container>-->
          </footer>
        </section>
        <section class="col-12 mb-4 mt-1">
          <footer class="row">
            <!-- Establecimiento -->
            <ng-container
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento
              "
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del establecimiento
              </h2>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Nombre</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.razon_social ===
                    informacionEstablecimiento_anterior.razon_social
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{ informacionEstablecimiento.razon_social }}</strong>
                </p>
              </div>
              <div
                class="col-sm-12 col-md-6"
                *ngIf="informacionEstablecimiento.matricula"
              >
                <label class="small mb-0">Matrícula mercantíl</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.matricula ===
                    informacionEstablecimiento_anterior.matricula
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{ informacionEstablecimiento.matricula }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Último Año Renovación Matricula Mercantil</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.ultimo_anio_renovado ===
                    informacionEstablecimiento_anterior.ultimo_anio_renovado
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento.ultimo_anio_renovado
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <!-- Inmueble -->
            <ng-container
              *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_inmueble"
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del inmueble
              </h2>
            </ng-container>
            <!-- Guia -->
            <ng-container
              *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_guia"
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Nombre de guia</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.nombre_gerente ===
                    informacionEstablecimiento_anterior.nombre_gerente
                      ? ''
                      : '#b2dfdb'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento.nombre_gerente
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <!-- Datos generales -->
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Último año renovado RNT</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.ultimo_anio_renovado_rnt ===
                  informacionEstablecimiento_anterior.ultimo_anio_renovado_rnt
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{
                  informacionEstablecimiento.ultimo_anio_renovado_rnt
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Dirección</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.direccion_comercial ===
                  informacionEstablecimiento_anterior.direccion_comercial
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{
                  informacionEstablecimiento.direccion_comercial
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6" *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_plataforma">
              <label class="small mb-0">País</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.desc_pais_notificacion ===
                  informacionEstablecimiento_anterior.desc_pais_notificacion
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{
                  informacionEstablecimiento.desc_pais_notificacion
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Departamento</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.departamento ===
                  informacionEstablecimiento_anterior.departamento
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{ informacionEstablecimiento.departamento }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Municipio</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.municipio ===
                  informacionEstablecimiento_anterior.municipio
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{ informacionEstablecimiento.municipio }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Cámara de comercio</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.desc_camara_largo ===
                  informacionEstablecimiento_anterior.desc_camara_largo
                    ? ''
                    : '#b2dfdb' ||
                      informacionEstablecimiento.descripcion_camara ===
                        informacionEstablecimiento_anterior.descripcion_camara
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{
                  informacionEstablecimiento.desc_camara_largo ||
                    datoSolicitudSharedModel.data.descripcion_camara
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Categoría</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.categoria ===
                  informacionEstablecimiento_anterior.categoria
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{ informacionEstablecimiento.categoria }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Sub categoría</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.subcategoria ===
                  informacionEstablecimiento_anterior.subcategoria
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{ informacionEstablecimiento.subcategoria }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6" *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble &&
            datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma &&
            datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia">
              <label class="small text-secondary mb-0">Actividad económica</label><br>
              <button type="button" (click)="consultarActividadesEstablecimiento(informacionEstablecimiento)"
              class="btn btn-primary btn-sm">
                Ver actividades
              </button>
            </div>
          </footer>
        </section>

        <section
          *ngIf="
            informacionEstablecimiento.numero_identificacion_usuario_provisional !==
            null
          "
          class="col-12 mb-4 mt-1"
        >
          <footer class="row">
            <!-- Usuario depositario -->
            <h2 class="col-12 h5 font-weight-bold mb-2">
              Depositario provisional
            </h2>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Nombre</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.nombre_usuario_provisional +
                    " " +
                    informacionEstablecimiento.apellido_usuario_provisional
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Número identificación</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.numero_identificacion_usuario_provisional
                }}</strong>
              </p>
            </div>
            <!-- <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Tipo identificación</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.ultimo_anio_renovado
                }}</strong>
              </p>
            </div> -->
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Cargo</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.cargo_usuario_provisional
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Correo electrónico</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.correo_usuario_provisional
                }}</strong>
              </p>
            </div>
          </footer>
        </section>

        <!-- Datos adicionales del prestador -->
        <section class="col-12 row mb-4">
          <h2 class="col-12 h5 font-weight-bold mb-2">
            Datos adicionales del prestador
          </h2>

          <div class="col-sm-12 col-md-6" *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma">
            <header class="mb-3">
              <h2 class="h6 font-weight-bold mb-4">Contacto</h2>
            </header>
            <footer class="row">
              <p class="col-5 small">Teléfono Fijo:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_telefonico ===
                  informacionEstablecimiento_anterior.numero_telefonico
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.numero_telefonico }}
              </p>
              <p class="col-5 small">Celular:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_celular ===
                  informacionEstablecimiento_anterior.numero_celular
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.numero_celular }}
              </p>
              <p class="col-5 small">Número fax:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.fax ===
                  informacionEstablecimiento_anterior.fax
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.fax }}
              </p>
              <p class="col-5 small">Correo eletrónico:</p>
              <p
                class="col-7 font-weight-bold small  text-break"
                [style.backgroundColor]="
                  informacionEstablecimiento.correo_electronico ===
                  informacionEstablecimiento_anterior.correo_electronico
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.correo_electronico }}
              </p>
            </footer>
          </div>

          <!-- Notificacion -->
          <div class="col-sm-12 col-md-6">
            <header class="mb-3">
              <h2 class="h6 font-weight-bold mb-4">Notificaciones</h2>
            </header>
            <footer class="row">
              <p class="col-5 small">Departamento notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.departamento_notificacion ===
                  informacionEstablecimiento_anterior.departamento_notificacion
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.departamento_notificacion }}
              </p>
              <p class="col-5 small">Municipio notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.municipio_notificacion ===
                  informacionEstablecimiento_anterior.municipio_notificacion
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.municipio_notificacion }}
              </p>
              <p class="col-5 small">Teléfono notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_telefonico_notificacion ===
                  informacionEstablecimiento_anterior.numero_telefonico_notificacion
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.numero_telefonico_notificacion }}
              </p>
              <p class="col-5 small">Dirección notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.direccion_notificacion ===
                  informacionEstablecimiento_anterior.direccion_notificacion
                    ? ''
                    : '#b2dfdb'
                "
              >
                {{ informacionEstablecimiento.direccion_notificacion }}
              </p>

              <div class="notification-email w-100" *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia &&
              datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble"
              [style.backgroundColor]="
                  informacionEstablecimiento.correo_electronico_notificacion ===
                  informacionEstablecimiento_anterior.correo_electronico_notificacion
                    ? ''
                    : '#b2dfdb'
                ">
                <p class="col-5 small">Correo electronico notificaciones:</p>
                <p  class="col-7 font-weight-bold small text-break">
                  {{ informacionEstablecimiento.correo_electronico_notificacion }}
                </p>
              </div>
            </footer>
          </div>
        </section>
      </section>
    </section>

    <!-- Version Anterior -->
    <section class="col-6">
      <section class="row">
        <h3 class="col-8 h4 font-weight-bold mt-1 border-anterior mt-4">
          Versión anterior
        </h3>
        <p class="col-4 small mt-4">
          Última actualización: <br /><strong>{{
            informacionEstablecimiento_anterior.fecha_ultima_actualizacion
              | date: "d/MMM/yyyy, h:mm a"
          }}</strong>
        </p>
        <section class="col-12">
          <footer class="row">
            <h2 class="col-12 h5 font-weight-bold mb-2 mt-2">
              Datos del prestador
            </h2>
            <ng-container
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia;
                else es_guia
              "
            >
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Representante legal</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.nombre_representante_legal ===
                    informacionEstablecimiento_anterior.nombre_representante_legal
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.nombre_representante_legal
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Número identificación</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.numero_identificacion_representante_legal ===
                    informacionEstablecimiento_anterior.numero_identificacion_representante_legal
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.numero_identificacion_representante_legal
                  }}</strong>
                </p>
              </div>
            </ng-container>

            <ng-template #es_guia>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Nombre representante legal</label>
                <p>
                  <strong>{{informacionEstablecimiento_anterior.nombre_representante_legal}}</strong>
                </p>
              </div>

              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Número identificación</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.numero_identificacion ===
                    informacionEstablecimiento_anterior.numero_identificacion
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.numero_identificacion
                  }}</strong>
                </p>
              </div>
            </ng-template>

            <ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma &&
            datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble &&
            datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia">
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Patrimonio neto</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.patrimonio_neto ===
                    informacionEstablecimiento_anterior.patrimonio_neto
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.patrimonio_neto
                      | currency: "COP"
                  }}</strong>
                </p>
              </div>
            </ng-container>

            <div
              class="col-sm-12 col-md-6"
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento
              "
            >
              <label class="small mb-0">Número de empleados</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_empleados ===
                  informacionEstablecimiento_anterior.numero_empleados
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.numero_empleados
                }}</strong>
              </p>
            </div>

            <ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento">
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Último Año Renovación Matricula Mercantil</label>
                <p
                [style.backgroundColor]="
                  informacionEstablecimiento.Ultimo_Anio_Renovado_Rm ===
                  informacionEstablecimiento_anterior.Ultimo_Anio_Renovado_Rm
                    ? ''
                    : '#ffecb3'
                "><strong>{{informacionEstablecimiento_anterior.Ultimo_Anio_Renovado_Rm}}</strong></p>
              </div>
            </ng-container>

            <!--<ng-container *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia">-->
              <div class="col-sm-12 col-md-12 text-right">
                <label class="small text-secondary mb-0">Actividad económica</label><br>
                <button type="button" class="btn btn-primary btn-sm" (click)="consultarActividadesPrestadorFuncionario()">
                  Ver actividades
                </button>
              </div>
            <!--</ng-container>-->
          </footer>
        </section>
        <section class="col-12 mb-4 mt-1">
          <footer class="row">
            <!-- Establecimiento -->
            <ng-container
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento
              "
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del establecimiento
              </h2>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Nombre</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.razon_social ===
                    informacionEstablecimiento_anterior.razon_social
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.razon_social
                  }}</strong>
                </p>
              </div>
              <div
                class="col-sm-12 col-md-6"
                *ngIf="informacionEstablecimiento.matricula"
              >
                <label class="small mb-0">Matrícula mercantíl</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.matricula ===
                    informacionEstablecimiento_anterior.matricula
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.matricula
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Último Año Renovación Matricula Mercantil</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.ultimo_anio_renovado ===
                    informacionEstablecimiento_anterior.ultimo_anio_renovado
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.ultimo_anio_renovado
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <!-- Inmueble -->
            <ng-container
              *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_inmueble"
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del inmueble
              </h2>
            </ng-container>
            <!-- Guia -->
            <ng-container
              *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_guia"
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
              <div class="col-sm-12 col-md-6">
                <label class="small mb-0">Nombre de guia</label>
                <p
                  [style.backgroundColor]="
                    informacionEstablecimiento.nombre_gerente ===
                    informacionEstablecimiento_anterior.nombre_gerente
                      ? ''
                      : '#ffecb3'
                  "
                >
                  <strong>{{
                    informacionEstablecimiento_anterior.nombre_gerente
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <!-- Datos generales -->
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Último año renovado RNT</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.ultimo_anio_renovado_rnt ===
                  informacionEstablecimiento_anterior.ultimo_anio_renovado_rnt
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.ultimo_anio_renovado_rnt
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Dirección</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.direccion_comercial ===
                  informacionEstablecimiento_anterior.direccion_comercial
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.direccion_comercial
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6" *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_plataforma">
              <label class="small mb-0">País</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.desc_pais_notificacion ===
                  informacionEstablecimiento_anterior.desc_pais_notificacion
                    ? ''
                    : '#b2dfdb'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.desc_pais_notificacion
                }}</strong>
              </p>
            </div>


            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Departamento</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.departamento ===
                  informacionEstablecimiento_anterior.departamento
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.departamento
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Municipio</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.municipio ===
                  informacionEstablecimiento_anterior.municipio
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.municipio
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Cámara de comercio</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.desc_camara_largo ===
                  informacionEstablecimiento_anterior.desc_camara_largo
                    ? ''
                    : '#ffecb3' ||
                      informacionEstablecimiento.descripcion_camara ===
                        informacionEstablecimiento_anterior.descripcion_camara
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.desc_camara_largo ||
                    datoSolicitudSharedModel.data.descripcion_camara
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Categoría</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.categoria ===
                  informacionEstablecimiento_anterior.categoria
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.categoria
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Sub categoría</label>
              <p
                [style.backgroundColor]="
                  informacionEstablecimiento.subcategoria ===
                  informacionEstablecimiento_anterior.subcategoria
                    ? ''
                    : '#ffecb3'
                "
              >
                <strong>{{
                  informacionEstablecimiento_anterior.subcategoria
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6"
            *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble && datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma && datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia">
              <label class="small text-secondary mb-0">Actividad económica</label><br>
              <button type="button" (click)="consultarActividadesEstablecimiento(informacionEstablecimiento)"
              class="btn btn-primary btn-sm">
                Ver actividades
              </button>
            </div>
          </footer>
        </section>
        <section
          *ngIf="
            informacionEstablecimiento_anterior.numero_identificacion_usuario_provisional !==
            null
          "
          class="col-12 mb-4 mt-1"
        >
          <footer class="row">
            <!-- Usuario depositario -->
            <h2 class="col-12 h5 font-weight-bold mb-2">
              Depositario provisional
            </h2>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Nombre</label>
              <p>
                <strong>{{
                  informacionEstablecimiento_anterior.nombre_usuario_provisional +
                    " " +
                    informacionEstablecimiento_anterior.apellido_usuario_provisional
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Número identificación</label>
              <p>
                <strong>{{
                  informacionEstablecimiento_anterior.numero_identificacion_usuario_provisional
                }}</strong>
              </p>
            </div>
            <!-- <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Tipo identificación</label>
              <p>
                <strong>{{
                  informacionEstablecimiento_anterior.ultimo_anio_renovado
                }}</strong>
              </p>
            </div> -->
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Cargo</label>
              <p>
                <strong>{{
                  informacionEstablecimiento_anterior.cargo_usuario_provisional
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="small mb-0">Correo electrónico</label>
              <p>
                <strong>{{
                  informacionEstablecimiento_anterior.correo_usuario_provisional
                }}</strong>
              </p>
            </div>
          </footer>
        </section>
        <section class="col-12 row mb-4">
          <h2 class="col-12 h5 font-weight-bold mb-2">
            Datos adicionales del prestador
          </h2>
          <div class="col-sm-12 col-md-6" *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_plataforma">
            <header class="mb-3">
              <h2 class="h6 font-weight-bold mb-4">Contacto</h2>
            </header>
            <footer class="row">
              <p class="col-5 small">Teléfono Fijo:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_telefonico ===
                  informacionEstablecimiento_anterior.numero_telefonico
                    ? ''
                    : '#ffecb3'
                "
              >
                {{ informacionEstablecimiento_anterior.numero_telefonico }}
              </p>
              <p class="col-5 small">Celular:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_celular ===
                  informacionEstablecimiento_anterior.numero_celular
                    ? ''
                    : '#ffecb3'
                "
              >
                {{ informacionEstablecimiento_anterior.numero_celular }}
              </p>
              <p class="col-5 small">Número fax:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.fax ===
                  informacionEstablecimiento_anterior.fax
                    ? ''
                    : '#ffecb3'
                "
              >
                {{ informacionEstablecimiento_anterior.fax }}
              </p>
              <p class="col-5 small">Correo eletrónico:</p>
              <p
                class="col-7 font-weight-bold small text-large"
                [style.backgroundColor]="
                  informacionEstablecimiento.correo_electronico ===
                  informacionEstablecimiento_anterior.correo_electronico
                    ? ''
                    : '#ffecb3'
                "
              >
                {{ informacionEstablecimiento_anterior.correo_electronico }}
              </p>
            </footer>
          </div>

          <!-- Notificacion -->
          <div class="col-sm-12 col-md-6">
            <header class="mb-3">
              <h2 class="h6 font-weight-bold mb-4">Notificaciones</h2>
            </header>

            <footer class="row">
              <p class="col-5 small">Departamento notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.departamento_notificacion ===
                  informacionEstablecimiento_anterior.departamento_notificacion
                    ? ''
                    : '#ffecb3'
                "
              >
                {{
                  informacionEstablecimiento_anterior.departamento_notificacion
                }}
              </p>
              <p class="col-5 small">Municipio notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.municipio_notificacion ===
                  informacionEstablecimiento_anterior.municipio_notificacion
                    ? ''
                    : '#ffecb3'
                "
              >
                {{ informacionEstablecimiento_anterior.municipio_notificacion }}
              </p>
              <p class="col-5 small">Teléfono notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.numero_telefonico_notificacion ===
                  informacionEstablecimiento_anterior.numero_telefonico_notificacion
                    ? ''
                    : '#ffecb3'
                "
              >
                {{
                  informacionEstablecimiento_anterior.numero_telefonico_notificacion
                }}
              </p>
              <p class="col-5 small">Dirección notificaciones:</p>
              <p
                class="col-7 font-weight-bold small"
                [style.backgroundColor]="
                  informacionEstablecimiento.direccion_notificacion ===
                  informacionEstablecimiento_anterior.direccion_notificacion
                    ? ''
                    : '#ffecb3'
                "
              >
                {{ informacionEstablecimiento_anterior.direccion_notificacion }}
              </p>
              <div class="notification-email w-100"
              *ngIf="datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia &&
              datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_inmueble"
              [style.backgroundColor]="
                  informacionEstablecimiento.correo_electronico_notificacion ===
                  informacionEstablecimiento_anterior.correo_electronico_notificacion
                    ? ''
                    : '#ffecb3'
                ">
                <p class="col-5 small">Correo electronico notificaciones:</p>
                <p class="col-7 font-weight-bold small  text-break">
                  {{ informacionEstablecimiento_anterior.correo_electronico_notificacion }}
                </p>
              </div>
            </footer>
          </div>
        </section>
      </section>
    </section>
  </section>
</ng-template>
